import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ScreeningService } from 'src/app/services/screening.service';

@Component({
  selector: 'app-datepick',
  templateUrl: './datepick.component.html',
  styleUrls: ['./datepick.component.less']
})
export class DatepickComponent implements OnInit {
  @Input() property : string;
  @Input() model : Date;
  @Input() label : string;
  @Output() modelChanged = new EventEmitter<any>();

  constructor(private screeningSrv : ScreeningService) { }

  ngOnInit() {
  }

  onChange(newName)
  {
    this.model = newName;
    // console.log(this.model);
    this.modelChanged.emit({
      name: this.property,
      value: this.model
    })
  }

}
